import React from 'react'
import AgentAvatar from './AgentAvatar'
import ReactDOM from 'react-dom'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import IconButton from '@material-ui/core/IconButton'
import Badge from '@material-ui/core/Badge'
import { makeStyles } from '@material-ui/core/styles'
import { getColoredSVG } from './js/getColoredSVG'
import TimeSinceCalculator from './TimeSinceCalculator'

const useStyles = makeStyles(theme => ({
  historyHeader: {
    backgroundColor: theme.palette.primary.main,
    borderTopRightRadius: 10,
    borderTopLeftRadius: 10,
    color: theme.palette.primary.contrastText,
    fontSize: '20px',
    fontWeight: 600,
    display: 'grid',
    gridTemplateColumns: '30px auto 48px',
    gridGap: 20,
    padding: 16,
    alignItems: 'center',
    height: 48
  },
  ieTableClassHeader: {
    backgroundColor: theme.palette.primary.main,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    alignItems: 'center',
    padding: '15px 20px 15px 15px',
    fontSize: '20px',
    border: 'none',
    width: '100%'
  },
  phoneHeader: {
    fontSize: 16,
    height: 48,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    display: 'grid',
    gridTemplateColumns: '30px auto 48px',
    gridGap: 20,
    padding: '4px 16px',
    alignItems: 'center'
  },
  phoneConvoList: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #C5C5C5',
    height: 'calc(100% - 56px)'
  },
  convoAvatar: {
    justifySelf: 'center'
  },
  backButton: {
    height: 35,
    width: 35
  },
  convoButton: {
    height: 48,
    width: 48
  },
  icon: {
    fill: theme.palette.primary.contrastText
  },
  buttonRoot: {
    padding: 0
  },
  badge: {
    color: 'white',
    backgroundColor: 'red'
  }
}))

function ConversationListItem (props) {
  const classes = useStyles()
  const convo = props.convo
  const meta = convo.attributes.meta
  let agent_name = meta.last_agent_name
  let avatar = meta.last_agent_avatar
  const lastMessage = meta.last_message

  if (!agent_name) {
    if (meta.first_send_type === 'user') {
      agent_name = meta.first_agent_name
    } else {
      agent_name = meta.bot_name
    }
  }

  if (!avatar) {
    avatar = props.botAvatar
  }

  return (
    <div key={convo.id} className='conversation-list-item' onClick={() => props.chooseConversation(convo)}>
      <div className={classes.convoAvatar}>
        <AgentAvatar avatarUrl={avatar} size={40} />
      </div>
      <div>{agent_name}</div>
      <TimeSinceCalculator time={lastMessage.timestamp} />
    </div>
  )
}

function ConversationHistory (props) {
  const setShowConversationHistory = props.setShowConversationHistory
  const conversationList = [...props.conversationList].slice(0, Math.min(15, props.conversationList.length))
  const setActiveConversationId = props.setActiveConversationId
  const startNewConvo = props.startNewConvo
  const classes = useStyles()
  const disableNewConversation = props.disableNewConversation || ''

  function chooseConversation (convo) {
    ReactDOM.unstable_batchedUpdates(() => {
      setActiveConversationId(convo.id)
      setTimeout(() => setShowConversationHistory(false), 170)
    })
  }

  function clickNewConvo () {
    setActiveConversationId('')
    startNewConvo()
    setShowConversationHistory(false)
  }

  let headerClass = classes.historyHeader
  let backClass = classes.backButton
  let convoClass = classes.convoButton
  let buttonRoot = classes.buttonRoot

  if (props.phone) {
    headerClass = classes.phoneHeader
    backClass = null
    convoClass = null
    buttonRoot = classes.buttonRoot
  }

  const primary = props.primaryColor
  const secondary = props.contrastColor
  const image = 'new_conversation'

  const coloredSVG = getColoredSVG({ image, primary, secondary })

  const base64data = btoa(unescape(encodeURIComponent(coloredSVG)))

  const header = (
    <div className={headerClass}>
      <IconButton className={backClass} onClick={() => setShowConversationHistory(false)} classes={{ root: buttonRoot }}>
        <ArrowBackIcon className={classes.icon} />
      </IconButton>
      <div>Conversations</div>
      {disableNewConversation
        ? <></>
        : (
          <IconButton onClick={clickNewConvo} className={convoClass} classes={{ root: buttonRoot }}>
            <img src={`data:image/svg+xml;base64,${base64data}`} height='40' width='40' />
          </IconButton>)}
    </div>
  )

  return (
    <>
      {header}
      <div className={props.phone ? classes.phoneConvoList : 'conversation-list-holder'}>
        <div className='conversation-list'>
          {conversationList.map(convo => (
            <ConversationListItem
              key={convo.id}
              convo={convo}
              chooseConversation={chooseConversation}
              // read={props.readReceipts[convo.id]}
              read
              botAvatar={props.botAvatar}
            />
          ))}
        </div>
      </div>
    </>
  )
}

export default ConversationHistory
